<template>
  <div class="container">
    <div ref="wrapper" class="pt-5">
      <HMS3ImageUploader
        inputName="community-room-chat-icon"
        :title="$t('COMMUNITY.LABEL.UPLOAD_IMAGE')"
        :description="$t('COMMUNITY.TEXT.UPLOAD_IMAGE')"
        :imageDescription="$t('COMMUNITY.LABEL.UPLOAD_IMAGE')"
        v-model="model.image"
        :cropper="false"
        class="mb-4"
      />
    </div>
    <form @submit.prevent="onConfirm()">
      <HMModalFooter
        :submitButton="$t('GENERAL.BUTTON.UPLOAD')"
        :discardButton="$t('GENERAL.BUTTON.CLOSE')"
        @close="onDiscard"
      />
    </form>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'CommunityCommentUploadImageModal',
  props: {
    model: {
      type: Object,
      default: () => {
        return {
          image: null,
        };
      },
    },
    confirm: null,
  },
  methods: {
    onConfirm() {
      this.confirm(this.model);
      this.$emit('close');
    },
    onDiscard() {
      if (this.discard) {
        this.discard();
      }
      this.$emit('close');
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
